// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark mode override for emoji-mart */
.emoji-mart[theme="dark"] {
  background-color: #1e1e1e !important;
  border-color: #333 !important;
}

.emoji-mart[theme="dark"] .emoji-mart-bar {
  background-color: #252525 !important;
  border-color: #333 !important;
}

.emoji-mart[theme="dark"] .emoji-mart-search input {
  background-color: #2a2a2a !important;
  border-color: #444 !important;
  color: #e0e0e0 !important;
}

.emoji-mart[theme="dark"] .emoji-mart-category-label span {
  background-color: #1e1e1e !important;
  color: #e0e0e0 !important;
}

.emoji-mart[theme="dark"] .emoji-mart-anchor {
  color: #999 !important;
}

.emoji-mart[theme="dark"] .emoji-mart-anchor:hover,
.emoji-mart[theme="dark"] .emoji-mart-anchor-selected {
  color: #fff !important;
}

.emoji-mart[theme="dark"] .emoji-mart-scroll {
  background-color: #1e1e1e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmojiGifStickerPicker/emoji-dark-mode.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Dark mode override for emoji-mart */\n.emoji-mart[theme=\"dark\"] {\n  background-color: #1e1e1e !important;\n  border-color: #333 !important;\n}\n\n.emoji-mart[theme=\"dark\"] .emoji-mart-bar {\n  background-color: #252525 !important;\n  border-color: #333 !important;\n}\n\n.emoji-mart[theme=\"dark\"] .emoji-mart-search input {\n  background-color: #2a2a2a !important;\n  border-color: #444 !important;\n  color: #e0e0e0 !important;\n}\n\n.emoji-mart[theme=\"dark\"] .emoji-mart-category-label span {\n  background-color: #1e1e1e !important;\n  color: #e0e0e0 !important;\n}\n\n.emoji-mart[theme=\"dark\"] .emoji-mart-anchor {\n  color: #999 !important;\n}\n\n.emoji-mart[theme=\"dark\"] .emoji-mart-anchor:hover,\n.emoji-mart[theme=\"dark\"] .emoji-mart-anchor-selected {\n  color: #fff !important;\n}\n\n.emoji-mart[theme=\"dark\"] .emoji-mart-scroll {\n  background-color: #1e1e1e !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
